//sets up routes for the module
//lazy loads
import store from '@/store';
const HomePage = () => import('@/modules/book/views/home/HomePage');

const PathForbidden = () => import('@/modules/book/views/error/PathForbidden');
const PathNotFound = () => import('@/modules/book/views/error/PathNotFound');

const BuildingsOverview = () => import('@/modules/book/views/building/buildingsOverview/BuildingsOverview');
const BuildingForm = () => import('@/modules/book/views/building/building/Building');


const FacilityOverview = () => import('@/modules/book/views/facility/facilityOverview/FacilityOverview');


const ContractList = () => import('@/modules/book/views/global-documentation/contract/ContractList.vue');
const DocumentationList = () => import('@/modules/book/views/global-documentation/documentation/DocumentationList.vue');
const GbuExport = () => import('@/modules/book/views/global-documentation/GbuExport.vue');

const Facility = () => import('@/modules/book/views/facility/facility/Facility');
// Facility Main Tabs
const FacilityDashboardTab = () => import('@/modules/book/views/facility/facility/tabs/FacilityDashboardTab')
const FacilityActivityTab = () => import('@/modules/book/views/facility/facility/tabs/FacilityActivityTab')
const FacilityProcessTab = () => import('@/modules/book/views/facility/facility/tabs/FacilityProcessTab')
const FacilityInfoTab = () => import('@/modules/book/views/facility/facility/tabs/FacilityInfoTab')

// Facility Info Tabs
const FacilityTechnicalInfoTab = () => import('@/modules/book/views/facility/facility/facilityInfoTabs/FacilityTechnicalInfoTab')
const FacilityContractInfoTab = () => import('@/modules/book/views/facility/facility/facilityInfoTabs/FacilityContractInfoTab')
const FacilityRoleInfoTab = () => import('@/modules/book/views/facility/facility/facilityInfoTabs/FacilityRoleInfoTab')
const FacilityProcessInfoTab = () => import('@/modules/book/views/facility/facility/facilityInfoTabs/FacilityProcessInfoTab')
const FacilityDocuInfoTab = () => import('@/modules/book/views/facility/facility/facilityInfoTabs/FacilityDocuInfoTab')
const FacilityTaskDocumentationTab = () => import('@/modules/book/views/facility/facility/facilityInfoTabs/FacilityTaskDocumentationTab')
const FacilityStateInfoTab = () => import('@/modules/book/views/facility/facility/facilityInfoTabs/FacilityStateInfoTab')

const ProcessOverview = () => import('@/modules/book/views/process/ProcessOverview');

const ProcessQuickstartOverview = () => import('@/modules/book/views/process/ProcessOverview');

//admin loads
const WorkerRoleOverview = () => import('@/modules/book/views/admin/WorkerRoleOverview');
const WorkerRoleForm = () => import('@/modules/book/views/admin/WorkerRoleForm');

const ProcessStepOverview = () => import('@/modules/book/views/admin/ProcessStepOverview');
const AddEditProcessStep = () => import('@/modules/book/views/admin/ProcessStepForm');

const ProcessBaseOverview = () => import('@/modules/book/views/admin/ProcessBaseOverview');
const AddEditProcessBase = () => import('@/modules/book/views/admin/ProcessBaseForm');

const ProcessAnswerOverview = () => import('@/modules/book/views/admin/ProcessAnswerOverview');

const ParameterOverview = () => import('@/modules/book/views/admin/ParameterOverview');
const ParameterForm = () => import('@/modules/book/views/admin/ParameterForm');

const Import = () => import('@/modules/book/views/admin/ImportForm');
const TaskBoard = () => import('@/modules/book/views/task/TaskBoard');

const QRCodeOverview = () => import('@/modules/book/views/admin/qrcode/QRCodeOverview');
const QRCodeImport = () => import('@/modules/book/views/admin/qrcode/QRCodeImport');
const QRCodeForm = () => import('@/modules/book/views/admin/qrcode/QRCodeForm');

const FacilityTypeOverview = () => import('@/modules/book/views/admin/facilityType/FacilityTypeOverview');
const FacilityTypeForm = () => import('@/modules/book/views/admin/facilityType/FacilityTypeForm');

const DocumentationRuleOverview = () => import('@/modules/book/views/admin/documentationRule/DocumentationRuleOverview');
const DocumentationRuleForm = () => import('@/modules/book/views/admin/documentationRule/DocumentationRuleForm');

const TestDataGeneration = () => import('@/modules/book/views/admin/TestDataGeneration');

// Dashboards
const Processes = () => import('@/modules/book/views/Processes');

// Public pages
const QRCodeFacilityOverview = () => import('@/modules/book/views/public/QRCodeFacilityOverview');
const QRCodeFacilityOnboarding = () => import('@/modules/book/views/public/QRCodeFacilityOnboarding')



const BOOK_URL = '/' + store.state.manager.bookModuleUrl;

//TODO test the translation behavior for core

const routes = [
  {
    path: BOOK_URL,
    alias: BOOK_URL + '/home',
    name: 'Home',
    component: HomePage,
    meta: {
      namespaces: ['book/dashboard', 'enums', 'book/facility', 'book/issue', 'book/technical-info'],
      isManager: true,
      isWorker: true
    }
  },
  {
    path: BOOK_URL + '/admin/worker-role',
    name: 'Worker Role',
    component: WorkerRoleOverview,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/worker-role/edit/:id?',
    name: 'Edit Worker Role',
    component: WorkerRoleForm,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/buildings',
    name: 'BuildingsOverview',
    component: BuildingsOverview,
    meta: {
      isOperator: true,
      namespaces: ['book/building', 'country'],
    }
  },
  {
    path: BOOK_URL + '/global/contract',
    name: 'ContractList',
    component: ContractList,
    meta: {
      isManager: true,
      namespaces: ['book/facility', 'enums'],
    }
  },
  {
    path: BOOK_URL + '/global/documentation',
    name: 'DocumentationList',
    component: DocumentationList,
    meta: {
      isManager: true,
      namespaces: ['book/facility', 'enums'],
    }
  },
  {
    path: BOOK_URL + '/gbu-export',
    name: 'GbuExport',
    component: GbuExport,
    meta: {
      isManager: true,
      namespaces: ['book/facility', 'enums'],
    }
  },
  {
    path: BOOK_URL + '/buildings/edit/:id',
    name: 'AddEditBuilding',
    component: BuildingForm,
    meta: {
      isOperator: true,
      namespaces: ['book/building', 'book/event', 'country', 'enums']
    }
  },
  {
    path: BOOK_URL + '/facilities',
    name: 'FacilityOverview',
    component: FacilityOverview,
    meta: {
      isManager: true,
      namespaces: ['book/facility']
    }
  },
  {
    path: BOOK_URL + '/facilities/edit/:id',
    name: 'Facility',
    component: Facility,
    meta: {
      isManager: true,
      namespaces: ['book/facility', 'enums']
    },
    children: [
      {
        path: BOOK_URL + '/facilities/edit/:id/dashboard',
        name: 'FacilityDashboardTab',
        component: FacilityDashboardTab,
        meta: {
          isManager: true,
          namespaces: ['book/facility', 'enums']
        }
      },
      {
        path: BOOK_URL + '/facilities/edit/:id/activities',
        name: 'FacilityActivityTab',
        component: FacilityActivityTab,
        meta: {
          isManager: true,
          namespaces: ['book/facility', 'book/event', 'enums']
        }
      },
      {
        path: BOOK_URL + '/facilities/edit/:id/processes',
        name: 'FacilityProcessTab',
        component: FacilityProcessTab,
        meta: {
          isManager: true,
          namespaces: ['book/facility', 'enums']
        },
        children: [

        ]
      },
      {
        path: BOOK_URL + '/facilities/edit/:id/info',
        name: 'FacilityInfoTab',
        component: FacilityInfoTab,
        meta: {
          isManager: true,
          namespaces: ['book/facility', 'enums', 'book/technical-info']
        },
        children: [
          {
            path: BOOK_URL + '/facilities/edit/:id/info/technical',
            name: 'FacilityTechnicalInfoTab',
            FacilityTechnicalInfoTab,
            meta: {
              isManager: true,
              namespaces: ['book/facility', 'enums', 'book/technical-info']
            },
          },
          {
            path: BOOK_URL + '/facilities/edit/:id/info/contracts',
            name: 'FacilityContractInfoTab',
            component: FacilityContractInfoTab,
            meta: {
              isManager: true,
              namespaces: ['book/facility', 'enums']
            },
          },
          {
            path: BOOK_URL + '/facilities/edit/:id/info/roles',
            name: 'FacilityRoleInfoTab',
            component: FacilityRoleInfoTab,
            meta: {
              isManager: true,
              namespaces: ['book/facility', 'enums']
            },
          },
          {
            path: BOOK_URL + '/facilities/edit/:id/info/processes',
            name: 'FacilityProcessInfoTab',
            component: FacilityProcessInfoTab,
            meta: {
              isManager: true,
              namespaces: ['book/facility', 'enums']
            },
          },
          {
            path: BOOK_URL + '/facilities/edit/:id/info/documentations',
            name: 'FacilityDocuInfoTab',
            component: FacilityDocuInfoTab,
            meta: {
              isManager: true,
              namespaces: ['book/facility', 'enums']
            },
          },
          {
            path: BOOK_URL + '/facilities/edit/:id/info/task-documentations',
            name: 'FacilityTaskDocumentationTab',
            component: FacilityTaskDocumentationTab,
            meta: {
              isManager: true,
              namespaces: ['book/facility', 'book/issue', 'enums']
            },
          },
          {
            path: BOOK_URL + '/facilities/edit/:id/info/state',
            name: 'FacilityStateInfoTab',
            component: FacilityStateInfoTab,
            meta: {
              isManager: true,
              namespaces: ['book/facility', 'enums', 'book/technical-info', 'book/process']
            },
          }
        ]
      }
    ]
  },
  {
    path: BOOK_URL + '/process/:processID',
    name: 'ProcessOverview',
    component: ProcessOverview,
    meta: {
      namespaces: ['book/process', 'book/technical-info', 'enums', 'book/facility']
    }
  },
  {
    path: BOOK_URL + '/quickstart/:facilityID/:processID',
    name: 'ProcessQuickstartOverview',
    component: ProcessQuickstartOverview,
    meta: {
      namespaces: ['book/process', 'book/technical-info', 'enums', 'book/facility']
    }
  },
  {
    path: BOOK_URL + '/admin/process/base',
    name: 'ProcessBaseOverview',
    component: ProcessBaseOverview,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/process/base/edit/:id?',
    name: 'ProcessBaseForm',
    component: AddEditProcessBase,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/process/steps',
    name: 'ProcessStepOverview',
    component: ProcessStepOverview,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/process/steps/edit/:id?',
    name: 'AddEditProcessStep',
    component: AddEditProcessStep,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/process/answer',
    name: 'ProcessAnswerOverview',
    component: ProcessAnswerOverview,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/parameter',
    name: 'ParameterOverview',
    component: ParameterOverview,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/parameter/edit/:id?',
    name: 'ParameterForm',
    component: ParameterForm,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/import',
    name: 'ImportForm',
    component: Import,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/qrcode',
    name: 'QRCodeOverview',
    component: QRCodeOverview,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/qrcode/import',
    name: 'QRCodeImport',
    component: QRCodeImport,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/qrcode/:id',
    name: 'QRCodeForm',
    component: QRCodeForm,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/testdata',
    name: 'TestDataGeneration',
    component: TestDataGeneration,
    meta: {
      isAdmin: true ,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/facility-type',
    name: 'FacilityTypeOverview',
    component: FacilityTypeOverview,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin']
    }
  },
  {
    path: BOOK_URL + '/admin/facility-type/edit/:id?',
    name: 'FacilityTypeForm',
    component: FacilityTypeForm,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin', 'enums']
    }
  },
  {
    path: BOOK_URL + '/admin/documentation-rule',
    name: 'DocumentationRuleOverview',
    component: DocumentationRuleOverview,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin', 'enums']
    }
  },
  {
    path: BOOK_URL + '/admin/documentation-rule/edit/:id?',
    name: 'DocumentationRuleForm',
    component: DocumentationRuleForm,
    meta: {
      isAdmin: true,
      namespaces: ['book/admin', 'enums']
    }
  },
  {
    path: BOOK_URL + '/processes',
    name: 'Processes',
    component: Processes,
    meta: {
      isManager: true,
      isWorker: true,
      namespaces: ['book/process', 'country', 'enums', 'book/technical-info'],
    }
  },
  {
    path: BOOK_URL + '/issue-board',
    name: 'TaskBoard',
    component: TaskBoard,
    meta: {
      namespaces: ['enums', 'book/issue'],
    }
  },
  {
    path: BOOK_URL + '/public/qrcode/:code',
    alias: BOOK_URL + '/public/:code',
    name: 'QRCodeFacilityOverview',
    component: QRCodeFacilityOverview,
    meta: {
      isPublic: true,
      namespaces: ['book/public', 'enums', 'country', 'book/technical-info']
    }
  },
  {
    path: BOOK_URL + '/public/qrcode/:code/onboarding',
    alias: BOOK_URL + '/public/:code/onboarding',
    name: 'QRCodeFacilityOnboarding',
    component: QRCodeFacilityOnboarding,
    meta: {
      namespaces: ['book/public', 'enums', 'book/technical-info']
    }
  },
  {
    path: '/404',
    name: '404',
    component: PathNotFound,
    meta: {
      isPublic: true
    }
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/403',
    name: '403',
    component: PathForbidden,
    meta: {
      isPublic: true
    }
  }
]

//TODO this gets imported and loaded, regardless of if the module is installed or not.
//TODO PUt into method and call in module install


export default routes
